module.exports = __webpack_public_path__ + "static/media/m9.7a134c0a.jpg";